import ReservationIndexVue from "@/views/reservation/ReservationIndex.vue";

const reservation = [
  {
    path: "/reservation",
    name: "reservation",
    component: ReservationIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default reservation;
